<template>
  <div class="color-bg">
    <canvas ref="canvas" :width="width" :height="height"></canvas>
  </div>
</template>

<style scoped>
.color-bg {
  width: 100%;
  height: 50%;
  position: absolute;
  left: 0;
  bottom: 0;
}
canvas{
  width: 100%;
  height: 100%;
}
</style>

<script>
import presets from '@/logic/colorpresets'
export default {
  name: 'ColorBg',
  data () {
    return {
      width: 100,
      height: 100,
      colors: ['#fff']
    }
  },
  mounted () {
    this.colors = presets.randomset()
    this.$nextTick().then(() => {
      this.$data.width = this.$el.clientWidth
      this.$data.height = this.$el.clientHeight
      const ctx = this.$refs.canvas.getContext('2d')
      // ctx.beginPath()
      // ctx.fillStyle = this.colors[0]
      window.setTimeout(() => {
        const cw = this.$data.width
        const ch = this.$data.height
        const COUNT = 12
        const MAXSIZE = 120
        const SCALERATE = 0.75
        let colorIndex = 0
        const setRndColor = () => {
          const index = colorIndex % this.colors.length
          ctx.fillStyle = this.colors[index]
          colorIndex = colorIndex + 1
        }
        let size = MAXSIZE
        // ctx.globalCompositeOperation = 'lighter'
        ctx.globalAlpha = 0.7
        for (let i = 0; i < COUNT; i++) {
          setRndColor()
          const x = cw * Math.random()
          const scale = size / MAXSIZE
          const y = ch * Math.random() * (1 - scale - 0.1) + ch * (scale + 0.1)
          ctx.beginPath()
          ctx.arc(x, y, size, 0, Math.PI * 2, true)
          ctx.fill()
          size = size * SCALERATE
        }
      }, 0)
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ColorBg.vue